import { type Weekday } from '@/features/plants/schemas/schedule-plant.schema.ts';
import { SCHEDULE_DAY_ROW_HEIGHT_PX } from '@/features/plants/components/plant-schedule/schedule/constants.ts';

export function ScheduleDaysColumn({
  days,
  onDayClick,
  onDayRef,
  dayColumnWidthPx = 104,
}: {
  days: readonly Weekday[];
  onDayClick: (day: Weekday) => void;
  onDayRef: (day: Weekday, el: HTMLDivElement | null) => void;
  dayColumnWidthPx?: number;
}) {
  return (
    <div className="sticky left-0 z-20 flex flex-col rounded-tl-lg rounded-bl-lg border border-gray-200 bg-gray-50">
      {days.map((day, idx) => (
        <div
          key={day}
          className={
            'flex flex-shrink-0 cursor-pointer items-start p-3 py-2 text-sm font-medium transition-colors hover:bg-gray-100 ' +
            (idx === days.length - 1 ? '' : 'border-b border-gray-100')
          }
          onClick={() => onDayClick(day)}
          ref={(el) => onDayRef(day, el)}
          style={{ width: dayColumnWidthPx, height: SCHEDULE_DAY_ROW_HEIGHT_PX }}
        >
          {day}
        </div>
      ))}
    </div>
  );
}
